import { Component, inject, input, Input, TemplateRef, viewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from '../../../common/components/button/button.component';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIcon } from '@angular/material/icon';

import { Room } from '../../../../shared-api/room';
import { SnackbarService } from '../../../services/snackbar/snackbar.service';
import { KnownMembership } from 'matrix-js-sdk/lib/@types/membership.js';

import { RoomService } from '../../../services/room/room.service';
import { RoomHelperService } from '../../../services/room/room-helper.service';
import { MatTableModule } from '@angular/material/table';

import { BaseInvite } from '../../../common/components/base-invite/base-invite';

type DialogContext = object;

@Component({
  selector: 'app-invite-mxid-dialog',
  imports: [ReactiveFormsModule, ButtonComponent, MatIcon, MatTableModule, MatProgressSpinnerModule, BaseInvite],
  templateUrl: './sb-invite-mxid-dialog.component.html',
  styleUrl: './sb-invite-mxid-dialog.component.scss'
})
/**
 * Dialog-Komponente zum (nachträglichen) Einladen einer Matrix-ID in einen bereits bestehenden Raum.
 *
 */
export class SbInviteMxidDialogComponent {
  readonly dialog = viewChild.required<TemplateRef<DialogContext>>('dialog');
  readonly matDialog = inject(MatDialog);
  /**
   * FormGroup für das Formular zum Einladen einer Matrix-ID.
   */

  customBtnWidth = input<string>();
  isDisabled = input<boolean>(false);
  isCreateRoomDialog = input<boolean>(false);
  showSpinner = false;
  /**
   * Aktuell in der GUI ausgewählter Raum.
   * @private
   */
  room: Room | null = null;
  private readonly roomService = inject(RoomService);
  private readonly roomHelperService = inject(RoomHelperService);

  private readonly snackbarService = inject(SnackbarService);

  /**
   * Setter für das Angular-Framework, um die aktuell in der GUI ausgewählten Raum zu setzen.
   *
   * @param roomId ID des aktuell in der GUI ausgewählten Raums
   */
  @Input()
  public set roomId(roomId: string) {
    (async (): Promise<void> => {
      this.room = await this.roomService.getRoom(roomId);
    })();
  }

  onInviteMembersClicked(): void {
    this.matDialog.open(this.dialog(), {
      width: '50rem',
      height: 'auto'
    });
  }

  hasRoomBeenAbandoned(): boolean {
    if (!this.room) {
      return false;
    }

    return this.roomHelperService.getRoomMembership(this.room.roomId) === KnownMembership.Leave;
  }

  /**
   * Versendet eine Einladung in den aktuellen Raum an eine Matrix-ID.
   */
  protected async invite(mxid: string | undefined | null): Promise<void> {
    if (!this.room) throw new Error('Einladung kann nicht versandt werden, da der Raum nicht gesetzt ist');

    if (!mxid) throw new Error('Einladung kann nicht versandt werden, da die Matrix-ID nicht gesetzt ist');

    const mxidWithoutTrailingS = mxid.split(/\s/).join('');

    try {
      await this.roomService.inviteIntoRoom(this.room.roomId, [{ mxid: mxidWithoutTrailingS }]);
    } catch (err: unknown) {
      console.error('inviteIntoRoom fehlgeschlagen', err);
      this.snackbarService.error('Einladung fehlschlagen');
    }
  }
}
